<!--
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: zb
 * @Date: 2019-06-13 13:44:36
 * @LastEditTime: 2019-08-08 19:23:03
 -->
<template>
  <div class="Transport-wrap">
    <section class="transport-logo">
      <img src="@/assets/img/wuliuchaxun.png" alt="">
    </section>
    <div class="tab-menu-content">
      <div class="tab-menu">
        <router-link :to="{name:'OrderInfo'}" tag="div" class="nav-link">
          <span>订单信息</span>
        </router-link>
        <div class="vertical" />
        <router-link :to="{name:'WaybillRoute'}" tag="div" class="nav-link">
          <span @click="isLogin()">运单轨迹</span>
        </router-link>
      </div>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import mixinsFunction from '@/utils/mixinsFunction'
export default {
  name: 'Monitor',
  mixins: [mixinsFunction],
  watch: {
    '$route'(to) {
      if (to.name == 'Monitor') {
        this.$router.push({ name: 'OrderInfo' })
      }
    }
  },
  created() {
    this.$router.push({ name: 'OrderInfo' })
  }
}
</script>

<style scoped lang='scss'>
  .tab-menu-content{
    box-shadow:0 2px 16px 0 rgba(0, 0, 0, 0.14);
    .tab-menu{
      width: 1200px;
      margin: 0 auto;
      display:flex;
    }
    .vertical{
      border-left: 1px solid #989898;
      margin-top: 8px;
      margin-bottom: 8px;
      opacity:0.5;
    }
    .nav-link{
      span{
        font-size: 16px;
      }
      width: 50%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      &.active{
        span{
          color: $base-color;
          font-weight: bold;
        }
      }
    }
  }
  .Transport-wrap{
    width: 100%;
  }
  .transport-logo{
    width: 100%;
    max-height: 388px;
    overflow: hidden;
    img{
      width: 100%;
      min-width: 1200px;
    }
  }
</style>
